export const COLOR = {
	YELLOW: '#ffc400',
};
